import React from 'react'
import { getParseDataFromHtmlString } from 'src/consumer/helpers/utilFunctions'

/**
 * Read-only view for Free-form Rich Text EMR section content.
 * Renders TipTap HTML as rich text (paragraph/list spacing preserved), not plain text.
 * Print-title contract: printTitleEnabled=false → do not render title;
 * printTitleEnabled=true → render printTitle when non-empty, else displayTitle.
 */
export default function FreeFormRichTextView({
  html,
  printTitleEnabled,
  printTitle = '',
  displayTitle = 'Free-form Rich Text',
  className = '',
  showTitle,
  title,
}) {
  if (!html || (typeof html === 'string' && html.trim() === '')) {
    return null
  }
  const trimmed = typeof html === 'string' ? html.trim() : ''
  if (!trimmed) return null

  const parsedContent = getParseDataFromHtmlString(trimmed, { preserveEmptyParagraphs: true })

  const effectivePrintTitleEnabled = printTitleEnabled !== undefined ? printTitleEnabled : Boolean(showTitle)
  const effectiveDisplayTitle = displayTitle != null && String(displayTitle).trim() ? String(displayTitle).trim() : (title != null && String(title).trim() ? String(title).trim() : 'Free-form Rich Text')
  const titleToShow =
    effectivePrintTitleEnabled && (printTitle != null && String(printTitle).trim() ? String(printTitle).trim() : effectiveDisplayTitle)

  return (
    <div className={className} style={{ marginBottom: '1em', wordWrap: 'break-word', wordBreak: 'break-word' }}>
      {effectivePrintTitleEnabled && titleToShow && (
        <h2
          style={{
            textDecoration: 'underline',
            display: 'block',
            marginBottom: '0.75em',
            marginTop: 0,
            fontSize: '18px',
            fontWeight: 700,
            color: '#1e293b',
            pageBreakAfter: 'avoid',
          }}
        >
          {titleToShow}
        </h2>
      )}
      <div
        className="free-form-rich-text-view tiptap-content"
        style={{
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          lineHeight: '1.6',
          fontSize: '14px',
        }}
      >
        {parsedContent}
      </div>
      <style>{`
        .free-form-rich-text-view.tiptap-content {
          max-width: 100%;
          overflow: visible;
        }
        .free-form-rich-text-view.tiptap-content p {
          margin: 0 0 0.8em 0;
          line-height: 1.6;
          text-align: left;
        }
        .free-form-rich-text-view.tiptap-content p:last-child { margin-bottom: 0; }
        /* Preserve empty paragraphs as blank lines (do not hide) */
        .free-form-rich-text-view.tiptap-content p:empty { min-height: 1.6em; margin: 0 0 0.8em 0; }
        .free-form-rich-text-view.tiptap-content ul,
        .free-form-rich-text-view.tiptap-content ol {
          margin: 0.8em 0;
          padding-left: 1.5em;
          line-height: 1.6;
        }
        .free-form-rich-text-view.tiptap-content li { margin-bottom: 0.4em; }
        .free-form-rich-text-view.tiptap-content strong,
        .free-form-rich-text-view.tiptap-content b { font-weight: 600; }
        .free-form-rich-text-view.tiptap-content em,
        .free-form-rich-text-view.tiptap-content i { font-style: italic; }
        .free-form-rich-text-view.tiptap-content u { text-decoration: underline; }
        .free-form-rich-text-view.tiptap-content h1,
        .free-form-rich-text-view.tiptap-content h2,
        .free-form-rich-text-view.tiptap-content h3,
        .free-form-rich-text-view.tiptap-content h4,
        .free-form-rich-text-view.tiptap-content h5,
        .free-form-rich-text-view.tiptap-content h6 {
          margin: 1em 0 0.5em 0;
          line-height: 1.3;
          font-weight: 600;
        }
        .free-form-rich-text-view.tiptap-content h1 { font-size: 1.3em; }
        .free-form-rich-text-view.tiptap-content h2 { font-size: 1.2em; }
        .free-form-rich-text-view.tiptap-content h3 { font-size: 1.1em; }
        .free-form-rich-text-view.tiptap-content blockquote {
          margin: 0.8em 0;
          padding-left: 1em;
          border-left: 3px solid #ccc;
          font-style: italic;
          color: #555;
        }
        .free-form-rich-text-view.tiptap-content code {
          background-color: #f4f4f4;
          padding: 0.1em 0.3em;
          border-radius: 3px;
          font-size: 0.9em;
        }
      `}</style>
    </div>
  )
}
